import React from 'react';
import {
    Row,
    Col,
    Typography,
    Skeleton,
    Result,
} from 'antd';
// import {
//     PrinterOutlined
// } from '@ant-design/icons';
import { useQuery } from '@tanstack/react-query';
import EditProfile from './components/EditProfile';
import FormUser from './components/FormUser';

function Profile() {

    const { isError, isLoading, data, error } = useQuery({
        queryKey: [`/api/user/profile`],
    })

    if (isLoading) {
        return <Skeleton active />
    }

    if (isError) {
        return <Result status="error" title={error.message} />
    };

    // console.log(data);
    return (
        <div style={{
            background: '#fff',
        }}>
            <Row justify='space-between' >
                <Col xs={24} md={12} >
                    <Typography.Title level={3}>
                        ข้อมูลส่วนตัว
                    </Typography.Title>
                </Col>
            </Row>
            <EditProfile userData={data} />
            <FormUser />
        </div>
    )
}

export default Profile